import React, { useEffect, useState } from "react";

import axios from "axios";
import StarProfileRightContent from "../../../components/StarProfile/StarCardComponent/StarProfileRightContent/StarProfileRightContent";

import PostContent from "../../../Screen/Post/PostContent";
import SkeletonArticle from "../../../components/Post_skaliton/SkeletonArticle";
import NodataAvailable from "../../Common/NodataAvailable";

const QAInstractions = ({ star_id }) => {
  const [modalShow, setModalShow] = React.useState(false);

  const [liveChat, setLiveChat] = useState([]);
  const [status, setStatus] = useState(false);

  useEffect(() => {
    let isMounted = true;
    axios.get(`/api/user/qnaStarAll/${star_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setLiveChat(res.data.livechats);
        }
      }
    });
  }, []);

  return (
    <div className="container StarContainer">
      <div className="row">
        <div className="col-sm-12 col-lg-8">
          {status &&
            [1, 2, 3, 4].map((valu) => <SkeletonArticle theme="dark" />)}
          {liveChat.length > 0 ? (
            liveChat.map((data) => (
              <>
                <PostContent key={data.id} post={data} />
              </>
            ))
          ) : (
            <NodataAvailable className="mt-5" />
          )}
        </div>

        <div className="col-md-4">
          <StarProfileRightContent star_id={star_id} />
        </div>
      </div>
    </div>
  );
};

export default QAInstractions;
